window.Shopify = window.Shopify || {};

Shopify.formatMoney = function (cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = String(format || Shopify.money_format || '');
  const placeholder = formatString.match(placeholderRegex);
  if (!placeholder) return formatString;

  const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
    if (isNaN(number) || number == null) return 0;
    const parts = (number / 100).toFixed(precision).split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    return parts[1] ? dollars + decimal + parts[1] : dollars;
  };

  let value = '';
  switch (placeholder[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 2, "'", '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }
  return formatString.replace(placeholderRegex, value);
};

Shopify.onError = function (xhr) {
  let data = {};
  try {
    data = JSON.parse(xhr.responseText);
  } catch {}
  if (data.message) {
    alert(`${data.message}(${data.status}): ${data.description}`);
    return;
  }
  const messages = Object.entries(data).flatMap(([attribute, list]) => [].concat(list).map((message) => `${attribute} ${message}`));
  alert(`Error : ${messages.join('; ')}.`);
};
